import Vue from 'vue'
const MyCommon = {
  // apiUrl: 'https://rxgw.acartool.com/',
  // apiUrl: 'http://api.rhcartool.com/', //测试服务器
  apiUrl: 'https://api.acartool.cn/',
  //获取当前时间，并返回 格式如2024/01/01-01:01:01
  getTime() {
    const timeStamp = new Date().getTime();
    const date = new Date(timeStamp);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);
    const seconds = ('0' + date.getSeconds()).slice(-2);
    const formattedDate = year + '/' + month + '/' + day + '-' + hours + ':' + minutes + ':' + seconds;
    return formattedDate
  },
  //时间格式转 yyyy-MM-DD 并且不够两位数 + 0
  formatDate(date) {
    const year = date.getFullYear(); // 获取年份
    const month = (date.getMonth() + 1).toString().length < 2 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1); // 获取月份，判断是否为两位数
    const day = date.getDate().toString().length < 2 ? '0' + date.getDate() : date.getDate(); // 获取日期，判断是否为两位数
    return year + '-' + month + '-' + day; // 返回格式化后的日期字符串
  },
  getUserInfo(vue) {
    vue.$webRequest({
      method: 'get',
      url: '/api/user/user_find'
    }).then((res)=>{
      if(res.data.code === 200){
        let localUserInfo = res.data.user_find
        localStorage.setItem("userInfo", JSON.stringify(localUserInfo));
        window.location = '/home';
      }else{
        vue.$message({
          message: res.data.msg,
          type: 'warning'
        });
      }
    }).catch((err) => {})
  },
  //判断URL用对应的触发对应的
  handleLink(vue, url) {
    if(url) {
      if(url.indexOf('http') > -1) {
        window.open(url, '_blank')
      }
      else {
        vue.$router.push(url)
      }
    }
  },
  isPC() {
    let flag = true;
    const innerWidth = window.innerWidth
      if(innerWidth <= 768) {
        flag = false
      }else {
        flag = true
      }
    return flag;
  },

  // 2026-02-2 后台富文本p标签下的字体全部自定义
  deleteMetadata(htmlString) {
    if(!htmlString){
      return '';
    }
    
    // 创建一个临时DOM元素来解析HTML字符串
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;

    // 找到所有的span元素
    const spans = tempDiv.querySelectorAll('p span');

    // 遍历每个span元素
    spans.forEach(span => {
      // 获取当前的style属性
      const style = span.getAttribute('style');

      if (style) {
        // 使用正则表达式移除font-size属性
        const newStyle = style.replace(/font-size\s*:\s*\d+px\s*;?/gi, '').trim();

        // 更新style属性
        if (newStyle) {
          span.setAttribute('style', newStyle);
        } else {
          span.removeAttribute('style');
        }
      }
    });

    // 获取处理后的HTML字符串
    return tempDiv.innerHTML;
  }

}

export default MyCommon